import React__default from 'react';
import { classNames } from '../../utils/class-names.mjs';

const ICON_WIDTH = 20;
const ICON_HEIGHT = 20;
function Icon({ children, className, ...props }) {
  return /* @__PURE__ */ React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: ICON_WIDTH,
    height: ICON_HEIGHT,
    viewBox: `0 0 ${ICON_WIDTH} ${ICON_HEIGHT}`,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    role: "presentation",
    className: classNames("lb-icon", className),
    ...props
  }, children);
}

export { ICON_HEIGHT, ICON_WIDTH, Icon };
//# sourceMappingURL=Icon.mjs.map
